import services from '../services'
import * as types from './mutation-types'

export const GetAppConfig = ({ commit }) => (
  services.getAppConfig().then(res => {
    commit(types.SET_CONFIG, res.data.data)
    return res.data.data
  })
)

export const SaveAppConfig = ({ commit }, payload) => (
  services.saveAppConfig(payload).then(res => {
    commit(types.SET_CONFIG, res.data.data)
    return res.data.data
  })
)
